var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo",attrs:{"position":"bottom","offset":[0, 18]}},[_c('span',{staticClass:"text"},[_vm._v("Powered by")]),_c('q-img',{staticStyle:{"width":"64px"},attrs:{"src":"https://static.bakmigm.co.id/menu-buyer/order/Bakmi-GM-Logo.svg"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }